<script setup>
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import UserSettings from '@/views/UserSettings.vue';
import iconSettings from '@/assets/images/icon_settings.png';
const route = useRoute();
const router = useRouter();

const menuItems = [
  { id: 'dashboard', path: '/dashboard', name: '首页' },
  { id: 'addmeeting', path: '/addmeeting', name: '实时会议' },
  { id: 'upload', path: '/upload', name: '上传录音' },
  { id: 'meetings', path: '/meetings', name: '会议列表' },
  { id: 'deepseek', path: '/deepseek', name: '深度搜索' },
  { id: 'meetinguser', path: '/meetinguser', name: '声纹管理' },
  { id: 'questans', path: '/questans', name: '问题帮助' },
];
const activeItem = ref(1);
watch(() => route.path, (value) => {
  menuItems.forEach(item => {
    if (item.path === value || value.startsWith(item.path)) {
      activeItem.value = item.id;
    }
  });
}, {
  immediate: true,
  deep: true
})
const getImageUrl = (id, isActive) => {
  return require(`@/assets/images/icon_${id}${isActive ? '_on' : ''}.png`);
};

const settingVisible = ref(false)

// 添加菜单点击处理，以便在切换菜单时添加过渡效果
const handleMenuClick = (path) => {
  // 使用router.push，而不是直接修改，这样可以触发路由过渡效果
  router.push(path);
}
</script>
<template>
  <div class="hszd-side">
    <!-- 标题 -->
    <div class="hszd-title">会声智达</div>
    <!-- 菜单 -->
    <div class="hszd-menu">
      <div v-for="(item, index) in menuItems" :key="item.id" class="menu-item" 
        :class="{ active: activeItem == item.id }"
        :style="{ 'animation-delay': `${index * 0.05}s` }"
        @click="handleMenuClick(item.path)">
        <!-- 图片是以id命名的 -->
        <img class="icon" :src="getImageUrl(item.id, activeItem == item.id)" />
        <span>{{ item.name }}</span>
      </div>
    </div>

    <div class="bottom-section">
      <img class="icon-setting" :src="iconSettings"
        @click="settingVisible=true" />
    </div>
    <UserSettings v-model:open="settingVisible" />
  </div>
</template>

<style scoped lang="less">
.hszd-side {
  width: var(--menu-width);
  height: 100%;
  background: linear-gradient(180deg, #246BF0 0%, #1347A2 100%);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  animation: slideInLeft 0.5s ease forwards;
}

.hszd-title {
  padding: 0 16px;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  margin: 40px auto 40px;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.hszd-menu {
  padding: 0 16px;
  overflow-y: auto;
  flex: 1;

  .menu-item {
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 12px;
    font-weight: 500;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    animation: fadeInRight 0.4s ease forwards;
    opacity: 0;
    transform: translateX(-10px);

    &.active {
      background-color: rgba(255, 255, 255, 0.9);
      color: #246BF0;
      font-weight: 600;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    &:hover:not(.active) {
      background-color: rgba(255, 255, 255, 0.15);
      transform: translateX(5px);
    }
    
    &:active {
      transform: scale(0.98);
    }

    .icon {
      height: 20px;
      width: 20px;
      margin-right: 12px;
      opacity: 0.9;
      transition: all 0.2s ease;
    }

    &:hover .icon {
      transform: scale(1.1);
    }

    &.active .icon {
      opacity: 1;
      transform: scale(1.1);
    }
  }
}

.bottom-section {
  padding: 20px;
  margin-top: auto;
  display: flex;
  justify-content: center;
}

.icon-setting {
  width: 28px;
  height: 28px;
  cursor: pointer;
  transition: transform 0.3s ease;
  filter: brightness(0) invert(1);
  opacity: 0.8;
  padding: 4px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.1);
}

.icon-setting:hover {
  transform: rotate(30deg);
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.2);
}

@keyframes slideInLeft {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>